export default "__VITE_ASSET__2bc8c24e__"